export default __webpack_public_path__ + "static/media/image-work-company-m@3x.568d06e2.webp";